import React from "react"
import { MovableCardWrapper, CardHeader, CardTitle, Detail } from "react-trello/dist/styles/Base"
import LaneScrollContext from "../../ReactTrello/Virtualized/LaneScrollContext";
import { BsTextParagraph } from "react-icons/bs"
import { GoComment } from "react-icons/go"
import "./styles.scss"
import moment from "moment";

export const CardBoard = (props) => {
  const {
    style,
    onCardClick,
    className,
    id,
    title,
    tags,
    cardDraggable,
    checklists,
    checklistsCount,
    comments,
    description,
    list,
    folder,
    due_date
  } = props
  const scrollIndex = React.useContext(LaneScrollContext) || { min: 0, max: Infinity }

  // using the context set in the ScrollableLane we can calculate what to actually render here
  if (props.index < scrollIndex.min || props.index > scrollIndex.max) {
    return null
  }

  return (
    <div className="card-kanban" onClick={() => onCardClick(props)}>
      <MovableCardWrapper data-id={id} style={style} className={className} title="">
        <Detail className="details-container">
        <div className="card-breadcrumb">{folder.name} / {list?.name}</div>
          <div className="tag-container">
            {tags &&
              tags.map((tag) => (
                <div className="tag-lane-card">
                  <span style={{ color: "#FFF", backgroundColor: tag?.tag_fg }}>{tag.name}</span>
                </div>
              ))}
          </div>
        </Detail>
        <CardHeader>
          <CardTitle draggable={cardDraggable}>
            <div className="react-trello-card-title" title={title}>
              {title}
            </div>
          </CardTitle>
        </CardHeader>
        <Detail className="details-container">
          <div className="tag-container checklist">
            <div className="checklist_item">
              {description && description !== "" && (
                <BsTextParagraph title="Este item tem uma descrição" size={14} />
              )}
              {comments && comments?.length > 0 && (
                <>
                  <GoComment title={`Este item tem ${comments?.length} comentário(s)`} size={14} />
                  {comments?.length}
                </>
              )}
              
              {/* {checklists && checklists.length > 0 && (
                <>
                  <RiCheckboxLine size={14} /> {checklistsCount?.resolved} / {checklistsCount?.unresolved}
                </>
              )} */}
            </div>
            <div>{moment(due_date).format("DD/MM/YYYY")  || ""}</div>
          </div>
        </Detail>
      </MovableCardWrapper>
    </div>
  )
}
